import React from "react";
import {
  Button,
  Paper,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  help: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
}));

const AiGlobalPromptFallbacks = ({
  aiAtendimentoPrompt,
  setAiAtendimentoPrompt,
  aiPrompt,
  setAiPrompt,
  aiPromptAftercare,
  setAiPromptAftercare,
  savingAtendimentoPrompt,
  savingPrompt,
  savingAftercarePrompt,
  onSaveAtendimento,
  onSavePostsale,
  onSaveAftercare,
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} variant="outlined">
      <Typography variant="h6">
        {i18n.t("settings.settings.aiFallbacks.title")}
      </Typography>
      <Typography className={classes.help} paragraph>
        {i18n.t("settings.settings.aiFallbacks.help")}
      </Typography>

      <Typography variant="subtitle2">
        {i18n.t("settings.settings.aiAssistant.atendimentoPromptTitle")}
      </Typography>
      <Typography className={classes.help}>
        {i18n.t("settings.settings.aiAssistant.atendimentoPromptHelp")}
      </Typography>
      <TextField
        label={i18n.t("settings.settings.aiAssistant.atendimentoPrompt")}
        margin="dense"
        variant="outlined"
        fullWidth
        multiline
        minRows={6}
        value={aiAtendimentoPrompt}
        onChange={e => setAiAtendimentoPrompt(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={onSaveAtendimento}
        disabled={savingAtendimentoPrompt}
      >
        {i18n.t("settings.settings.aiAssistant.saveAtendimentoPrompt")}
      </Button>

      <Typography variant="subtitle2">
        {i18n.t("settings.settings.aiAssistant.postSalePromptTitle")}
      </Typography>
      <Typography className={classes.help}>
        {i18n.t("settings.settings.aiAssistant.postSalePromptHelp")}
      </Typography>
      <TextField
        label={i18n.t("settings.settings.aiAssistant.prompt")}
        margin="dense"
        variant="outlined"
        fullWidth
        multiline
        minRows={6}
        value={aiPrompt}
        onChange={e => setAiPrompt(e.target.value)}
        helperText={i18n.t("settings.settings.aiAssistant.promptHelp")}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={onSavePostsale}
        disabled={savingPrompt}
      >
        {i18n.t("settings.settings.aiAssistant.savePrompt")}
      </Button>

      <Typography variant="subtitle2">
        {i18n.t("settings.settings.aiAssistant.aftercarePromptTitle")}
      </Typography>
      <Typography className={classes.help}>
        {i18n.t("settings.settings.aiAssistant.aftercarePromptHelp")}
      </Typography>
      <TextField
        label={i18n.t("settings.settings.aiAssistant.aftercarePrompt")}
        margin="dense"
        variant="outlined"
        fullWidth
        multiline
        minRows={6}
        value={aiPromptAftercare}
        onChange={e => setAiPromptAftercare(e.target.value)}
        helperText={i18n.t("settings.settings.aiAssistant.promptHelp")}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={onSaveAftercare}
        disabled={savingAftercarePrompt}
      >
        {i18n.t("settings.settings.aiAssistant.saveAftercarePrompt")}
      </Button>
    </Paper>
  );
};

export default AiGlobalPromptFallbacks;
